var DateFormat;
(function(DateFormat) {
    DateFormat["dmy"] = "dmy";
    DateFormat["ymd"] = "ymd";
    DateFormat["mdy"] = "mdy";
})(DateFormat || (DateFormat = {}));

export { DateFormat };
//# sourceMappingURL=types.js.map
